const en = {
  "Home": "Home",
  "Add": "Add",
  "Adding": "Adding",
  "Editing": "Editing",
  "Edit": "Edit",
  "Delete": "Delete",
  "Save": "Save",
  "Cancel": "Cancel",
  "Close": "Close",
  "Open": "Open",
  'View': 'View',
  'Remove': 'Remove',
  'Sensor': 'Sensor',
  'Room': 'Room',
  'TotalBuildingConsumption': 'Building Consumption',
  'EnergyDistribution': ' Electric Power Distribution',
  'Common': 'General Data',
  'WeatherStation': 'Weather Station',
  'VisitorsMonth': 'Visitors per month',
  'VisitorsYear': 'Visitors per year',
  'Alarms': 'Alarms',
  'DayWithoutAccidents': 'Days without accidents',
  'InternalTemperature': 'Internal Temperature',
  'OutsideTemperature': 'Outside Temperature',
  'WindSpeed': 'Wind Speed',
  'Humidity': 'Humidity',
  'Еlectricity': 'Еlectricity',
  'Water': 'Water',
  'Air': 'Air',
  'Gas': 'Gas',
  'Production': 'Production',
  'Compressor': 'Compressors',
  'Lighting': 'Illumination',
  'Machines': 'Machines',
  'Administration': 'Administration',
  'Animation': 'Animation',
  'Animations': 'Animations',
  'January': 'January',
  'February': 'February',
  'March': 'March',
  'April': 'April',
  'May': 'May',
  'June': 'June',
  'July': 'July',
  'August': 'August',
  'September': 'September',
  'October': 'October',
  'November': 'November',
  'December': 'December',
  'Main Scene': 'Main Scene',
  'Main Hall': 'Main Hall',
  'Assembly Line': 'Assembly line',
  'Innovation Hub': 'Innovation Hub'
};

export default en;